import type { DocumentNode } from 'graphql'
import gql from 'graphql-tag'

const postBillingInfoUpdate: DocumentNode = gql`
  mutation PostBillingInfoUpdate($tokenId: String!, $threeDSecureActionResultTokenId: String) {
    setSubscriptionBillingInfo(input: { tokenId: $tokenId, threeDSecureActionResultTokenId: $threeDSecureActionResultTokenId }) {
      ... on AccountSetBillingInfoResponse {
        id
      }
      ... on AccountSetBillingInfoInvalidError {
        error {
          message
          type
          transactionError {
            message
            merchantAdvice
          }
        }
      }
      ... on AccountSetBillingInfoError {
        error {
          message
          transactionError {
            code
            message
            declineCode
            merchantAdvice
            transactionId
            threeDSecureActionTokenId
          }
          type
        }
      }
    }
  }
`

export default postBillingInfoUpdate
